const ensureMeta = (attrName, attrVal) => {
  let tag = document.head.querySelector(`meta[${attrName}="${attrVal}"]`);
  if (!tag) { tag = document.createElement('meta'); tag.setAttribute(attrName, attrVal); document.head.appendChild(tag); }
  return tag;
};

export function setSEO({ title, description, keywords, ogImage, ogType='website', url }){
  const href = url || window.location.href;
  if (title) { document.title = title; ensureMeta('property','og:title').setAttribute('content', title); ensureMeta('name','twitter:title').setAttribute('content', title); }
  if (description) { ensureMeta('name','description').setAttribute('content', description); ensureMeta('property','og:description').setAttribute('content', description); ensureMeta('name','twitter:description').setAttribute('content', description); }
  if (keywords) { ensureMeta('name','keywords').setAttribute('content', keywords); }
  ensureMeta('property','og:type').setAttribute('content', ogType);
  ensureMeta('property','og:url').setAttribute('content', href);
  ensureMeta('name','twitter:card').setAttribute('content','summary_large_image');
  if (ogImage) { ensureMeta('property','og:image').setAttribute('content', ogImage); ensureMeta('name','twitter:image').setAttribute('content', ogImage); }
  let link = document.head.querySelector('link[rel="canonical"]');
  if (!link) { link = document.createElement('link'); link.setAttribute('rel','canonical'); document.head.appendChild(link); }
  link.setAttribute('href', href);
  // Basic AI/Search helper hints
  if (description) { ensureMeta('name','summary').setAttribute('content', description.slice(0, 240)); }
}

export function addJSONLD(json){
  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.text = JSON.stringify(json);
  document.head.appendChild(script);
}

export function addLocalBusiness({ name, image, telephone, country='CO' }){
  addJSONLD({ '@context':'https://schema.org/', '@type':'LocalBusiness', name, image, telephone, address:{ '@type':'PostalAddress', addressCountry: country } });
}

export function addBreadcrumb(items){
  addJSONLD({ '@context':'https://schema.org/', '@type':'BreadcrumbList', itemListElement: items.map((it, idx)=>({ '@type':'ListItem', position: idx+1, name: it.name, item: it.item })) });
}

export function addProduct({ name, image, description, sku, brand='', price, currency='COP', url }){
  addJSONLD({ '@context':'https://schema.org/', '@type':'Product', name, image:[image], description, sku, brand:{ '@type':'Brand', name: brand || 'Brand' }, offers:{ '@type':'Offer', priceCurrency: currency, price: String(price||''), availability:'https://schema.org/InStock', url } });
}

export function addFAQ(items){
  addJSONLD({ '@context':'https://schema.org/', '@type':'FAQPage', mainEntity: items.map(q=>({ '@type':'Question', name: q.q, acceptedAnswer:{ '@type':'Answer', text: q.a } })) });
}

export function addSitelinksSearchBox(siteUrl){
  addJSONLD({ '@context': 'https://schema.org', '@type': 'WebSite', url: siteUrl, potentialAction: { '@type': 'SearchAction', target: `${siteUrl}/buscar?q={search_term_string}`, 'query-input': 'required name=search_term_string' } });
}
